<template>
  <header class="top-nav">
    <div class="nav-inner">
      <!-- Logo -->
      <div class="nav-logo" @click="$router.push('/')">
        <img src="@/assets/images/logo.png" class="logo-img" alt="云知微数据" />
      </div>

      <!-- 主导航 -->
      <nav class="nav-menu">
        <router-link to="/" class="nav-item" exact>首页</router-link>
        <router-link to="/news" class="nav-item">资讯</router-link>
        <div
          class="nav-item nav-dropdown"
          :class="{ active: isDataActive }"
          @mouseenter="showDataMenu = true"
          @mouseleave="showDataMenu = false"
        >
          <span>数据</span>
          <i class="el-icon-arrow-down"></i>
          <transition name="fade-down">
            <div v-show="showDataMenu" class="dropdown-panel">
              <div class="dropdown-grid">
                <router-link to="/data/primary-market" class="dropdown-item">
                  <i class="el-icon-coin"></i>
                  <div>
                    <div class="item-title">一级市场投融资</div>
                  </div>
                </router-link>
                <router-link to="/data/enterprise-finance" class="dropdown-item">
                  <i class="el-icon-data-analysis"></i>
                  <div>
                    <div class="item-title">企业财务数据</div>
                  </div>
                </router-link>
                <router-link to="/data/commodity" class="dropdown-item">
                  <i class="el-icon-goods"></i>
                  <div>
                    <div class="item-title">大宗商品价格</div>
                  </div>
                </router-link>
                <router-link to="/data/international-macro" class="dropdown-item">
                  <i class="el-icon-place"></i>
                  <div>
                    <div class="item-title">宏观数据</div>
                  </div>
                </router-link>
                <router-link to="/data/industry" class="dropdown-item">
                  <i class="el-icon-office-building"></i>
                  <div>
                    <div class="item-title">行业数据</div>
                  </div>
                </router-link>
              </div>
            </div>
          </transition>
        </div>
        <router-link to="/research" class="nav-item">报告</router-link>
        <router-link to="/knowledge" class="nav-item">知识库</router-link>
        <router-link to="/custom" class="nav-item">定制化</router-link>
      </nav>

      <!-- 右侧 -->
      <div class="nav-right">
        <div class="nav-search">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索数据、资讯..."
            prefix-icon="el-icon-search"
            size="small"
            clearable
            @keyup.enter.native="doSearch"
          />
        </div>

        <!-- 未登录 -->
        <template v-if="!isLoggedIn">
          <router-link to="/login" class="login-btn">
            <i class="el-icon-user"></i>
            <span>登录 / 注册</span>
          </router-link>
        </template>

        <!-- 已登录 -->
        <template v-else>
          <!-- 订阅按钮（未订阅用户） -->
          <router-link v-if="!hasDataAccess" to="/subscription" class="sub-btn">
            <i class="el-icon-star-off"></i> 订阅解锁
          </router-link>

          <!-- 用户头像下拉 -->
          <el-dropdown @command="handleUserCmd">
            <span class="user-avatar-wrap">
              <el-avatar :size="32" icon="el-icon-user-solid" style="background:#2563eb;cursor:pointer" />
              <span class="user-name-nav">{{ currentUser && currentUser.username }}</span>
              <i class="el-icon-arrow-down" style="font-size:11px;color:#9ca3af"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="subscription" icon="el-icon-star-on">
                {{ hasDataAccess ? '我的订阅' : '订阅升级' }}
              </el-dropdown-item>
              <el-dropdown-item command="logout" icon="el-icon-switch-button" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TopNav',
  data() {
    return {
      searchKeyword: '',
      showDataMenu: false
    }
  },
  computed: {
    isDataActive() { return this.$route.path.startsWith('/data') },
    isLoggedIn() { return this.$store.getters.isLoggedIn },
    hasDataAccess() { return this.$store.getters.hasDataAccess },
    currentUser() { return this.$store.getters.currentUser }
  },
  async created() {
    if (this.isLoggedIn) await this.$store.dispatch('refreshMembership')
  },
  watch: {
    isLoggedIn(val) {
      if (val) this.$store.dispatch('refreshMembership')
    }
  },
  methods: {
    doSearch() {
      const q = this.searchKeyword.trim()
      if (!q) return
      this.$router.push({ path: '/search', query: { q } }).catch(() => {})
    },
    handleUserCmd(cmd) {
      if (cmd === 'logout') {
        this.$store.dispatch('logout')
        this.$router.push('/login').catch(() => {})
      } else if (cmd === 'subscription') {
        this.$router.push('/subscription').catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #2563eb;
$nav-height: 60px;

.top-nav {
  position: sticky;
  top: 0;
  z-index: 1000;
  height: $nav-height;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.nav-inner {
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 32px;
}

// Logo
.nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;

  .logo-img {
    height: 32px;
    width: auto;
    object-fit: contain;
  }
}

// 导航菜单
.nav-menu {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.nav-badge {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.4;
  vertical-align: middle;
  margin-left: 3px;

  &.free {
    background: #dcfce7;
    color: #16a34a;
  }

  &.paid {
    background: #fef3c7;
    color: #d97706;
  }
}

.nav-item {
  position: relative;
  padding: 8px 20px;
  font-size: 15px;
  color: #6b7280;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    color: #1f2937;
    background: #f3f4f6;
  }

  &.router-link-exact-active,
  &.active {
    color: $primary;
    background: #eff6ff;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 2px;
      background: $primary;
      border-radius: 1px;
    }
  }

  .el-icon-arrow-down {
    font-size: 12px;
    transition: transform 0.3s;
  }
}

// 下拉面板
.nav-dropdown {
  position: relative;

  &:hover .el-icon-arrow-down {
    transform: rotate(180deg);
  }
}

.dropdown-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  min-width: 380px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.dropdown-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.25s ease;
  color: #4b5563;

  &:hover {
    background: #f3f4f6;
    color: #1f2937;

    i {
      color: $primary;
    }
  }

  &.router-link-active {
    background: #eff6ff;
    color: $primary;
  }

  i {
    font-size: 22px;
    color: #9ca3af;
    transition: all 0.3s;
  }

  .item-title {
    font-size: 14px;
    font-weight: 500;
  }

  .item-desc {
    font-size: 11px;
    color: #9ca3af;
    margin-top: 2px;
  }
}

// 右侧
.nav-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.nav-search {
  width: 200px;

  ::v-deep .el-input__inner {
    border-radius: 20px !important;
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    padding-left: 34px;
    background: #f9fafb !important;
    border: 1px solid #e5e7eb !important;
  }

  ::v-deep .el-input__prefix {
    left: 10px;
    color: #9ca3af;
  }
}

.login-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  border-radius: 20px;
  font-size: 13px;
  color: $primary;
  text-decoration: none;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #dbeafe;
    border-color: #93c5fd;
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.12);
  }
}

.sub-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #d97706;
  text-decoration: none;
  border: 1px solid #fde68a;
  background: #fffbeb;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover { background: #fef3c7; }
}

.admin-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #7c3aed;
  text-decoration: none;
  border: 1px solid #ddd6fe;
  background: #f5f3ff;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover { background: #ede9fe; }
}

.user-avatar-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.user-name-nav {
  font-size: 13px;
  color: #374151;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 动画
.fade-down-enter-active, .fade-down-leave-active {
  transition: all 0.25s ease;
}
.fade-down-enter, .fade-down-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-8px);
}
</style>
